import React from "react";
import { formatLocalDateTime } from "../../../utils/dateTime";

const RecordsPanel = ({ open, series, selection, onToggle, onSelect }) => (
    <>
        <div className="graph-page__records-bar">
            <button type="button" className="graph-page__button" aria-expanded={open} aria-controls="graph-records-panel" onClick={onToggle}>
                {open ? "Hide Records" : "Show Records"}
            </button>
        </div>
        {open && (
            <section id="graph-records-panel" className="graph-page__card graph-page__records" aria-labelledby="graph-records-heading">
                <div className="graph-page__card-head">
                    <h2 id="graph-records-heading">Records</h2>
                    <p>Each row is the sample returned for that tag. Rows that share a timestamp stay separate.</p>
                </div>
                <div className="graph-page__records-body" data-hmi-drawer="" data-hmi-scroll="contained">
                    {series.length === 0 ? (
                        <p className="graph-page__empty">Records appear here after Fetch Data.</p>
                    ) : series.map((item) => {
                        const rows = Array.isArray(item.chart.tableData) ? item.chart.tableData : [];
                        return (
                            <div key={item.chart.id} className="graph-page__record-group">
                                <h3 className="graph-page__record-title">
                                    <span className="graph-page__swatch" style={{ background: item.color }} aria-hidden="true" />
                                    <span>{item.label}</span>
                                </h3>
                                {rows.length === 0 ? (
                                    <p className="graph-page__empty">No history rows were returned for this range.</p>
                                ) : (
                                    <table className="graph-page__table">
                                        <thead><tr><th>Timestamp</th><th>Value</th></tr></thead>
                                        <tbody>
                                            {rows.map((row, index) => {
                                                const selected = selection?.seriesId === item.chart.id && selection.index === index;
                                                return (
                                                    <tr
                                                        key={row.id != null ? `${item.chart.id}-${row.id}` : `${item.chart.id}-${index}`}
                                                        id={`graph-record-${item.chart.id}-${index}`}
                                                        className={selected ? "is-selected" : undefined}
                                                        aria-selected={selected}
                                                        tabIndex={0}
                                                        onClick={() => onSelect(item.chart.id, index)}
                                                        onKeyDown={(event) => {
                                                            if (event.key === "Enter" || event.key === " ") {
                                                                event.preventDefault();
                                                                onSelect(item.chart.id, index);
                                                            }
                                                        }}
                                                    >
                                                        <td className="graph-page__mono">{formatLocalDateTime(row.timestamp)}</td>
                                                        <td className="graph-page__value">{row.value}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                )}
                            </div>
                        );
                    })}
                </div>
            </section>
        )}
    </>
);

export default RecordsPanel;
